import IndustryWiseStatistics from "./QuickLinks&Industry/Statistics";
import LoginHistoryStatistics from "./LoginHistory/LoginHistoryStatistics";
import MemberStatistics from "./MemberStatistics/MemberStatistics";
import MemberWiseTables from "./MembersWiseTables/Tables";
import PendingMembers from "./PendingMember/Members";
import GeneralCard from "./GeneralCard";

const Dashboard = () => {
  return (
    <>
      <GeneralCard />
      <MemberStatistics />
      <PendingMembers />
      <LoginHistoryStatistics />
      <MemberWiseTables />
      <IndustryWiseStatistics />
    </>
  );
};

export default Dashboard;
